/**
 * @generated SignedSource<<657fe69fbae1d931b271007cfa02f2d4>>
 * @relayHash 895535a62a5513fa91d9424b03f922de
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0cd6689f58d70d089c5ce0d16c3651046806b0d99434650a0e51495ec7741474

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraProjectType = "BUSINESS" | "CUSTOMER_SERVICE" | "PRODUCT_DISCOVERY" | "SERVICE_DESK" | "SOFTWARE" | "%future added value";
export type JiraVersionSortField = "DESCRIPTION" | "NAME" | "RELEASE_DATE" | "SEQUENCE" | "START_DATE" | "%future added value";
export type JiraVersionStatus = "ARCHIVED" | "RELEASED" | "UNRELEASED" | "%future added value";
export type SortDirection = "ASC" | "DESC" | "%future added value";
export type JiraVersionSortInput = {
  order: SortDirection;
  sortByField: JiraVersionSortField;
};
export type ProjectVersionsComponentQuery$variables = {
  cloudId: string;
  filter: ReadonlyArray<JiraVersionStatus | null>;
  initialLoadCount: number;
  isVersionPerProjectLimitEnabled: boolean;
  projectKey: string;
  searchString: string;
  sortBy: JiraVersionSortInput;
};
export type ProjectVersionsComponentQuery$data = {
  readonly jira: {
    readonly jiraProjectByKey: {
      readonly canEditVersions: {
        readonly canPerform: boolean;
      } | null;
      readonly jiraProjectType: JiraProjectType | null;
      readonly key: string;
      readonly name: string;
      readonly projectId: string;
      readonly versionPerProjectLimit?: {
        readonly limit: number | null;
        readonly releasedVersionsCount: number | null;
        readonly unreleasedVersionsCount: number | null;
      } | null;
      readonly versions: {
        readonly __id: string;
        readonly edges: ReadonlyArray<{
          readonly __typename: "JiraVersionEdge";
        } | null> | null;
        readonly errors: ReadonlyArray<{
          readonly extensions: ReadonlyArray<{
            readonly statusCode: number | null;
          }> | null;
        }> | null;
      };
    };
  };
  readonly " $fragmentSpreads": FragmentRefs<"Table_ReleasesProjectVersions">;
};
export type ProjectVersionsComponentQuery = {
  response: ProjectVersionsComponentQuery$data;
  variables: ProjectVersionsComponentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filter"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "initialLoadCount"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isVersionPerProjectLimitEnabled"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectKey"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchString"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sortBy"
},
v7 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "projectKey"
  }
],
v8 = {
  "kind": "ScalarField",
  "name": "projectId"
},
v9 = {
  "kind": "ScalarField",
  "name": "name"
},
v10 = {
  "kind": "ScalarField",
  "name": "key"
},
v11 = {
  "alias": "jiraProjectType",
  "kind": "ScalarField",
  "name": "projectType"
},
v12 = [
  {
    "kind": "Literal",
    "name": "type",
    "value": "MANAGE_VERSIONS"
  }
],
v13 = {
  "kind": "ScalarField",
  "name": "canPerform"
},
v14 = {
  "condition": "isVersionPerProjectLimitEnabled",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "concreteType": "JiraVersionsPerProjectLimit",
      "kind": "LinkedField",
      "name": "versionPerProjectLimit",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "limit"
        },
        {
          "kind": "ScalarField",
          "name": "unreleasedVersionsCount"
        },
        {
          "kind": "ScalarField",
          "name": "releasedVersionsCount"
        }
      ]
    }
  ]
},
v15 = {
  "kind": "Variable",
  "name": "filter",
  "variableName": "filter"
},
v16 = {
  "kind": "Variable",
  "name": "searchString",
  "variableName": "searchString"
},
v17 = {
  "kind": "Variable",
  "name": "sortBy",
  "variableName": "sortBy"
},
v18 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v19 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v20 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v21 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "endCursor"
    },
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    }
  ]
},
v22 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v23 = [
  (v15/*: any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "initialLoadCount"
  },
  (v16/*: any*/),
  (v17/*: any*/)
],
v24 = {
  "kind": "ScalarField",
  "name": "id"
},
v25 = {
  "kind": "ScalarField",
  "name": "totalCount"
},
v26 = [
  (v25/*: any*/)
],
v27 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": "DONE"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ProjectVersionsComponentQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "args": (v7/*: any*/),
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "jiraProjectByKey",
                "plural": false,
                "selections": [
                  {
                    "kind": "RequiredField",
                    "field": (v8/*: any*/),
                    "action": "THROW"
                  },
                  {
                    "kind": "RequiredField",
                    "field": (v9/*: any*/),
                    "action": "THROW"
                  },
                  {
                    "kind": "RequiredField",
                    "field": (v10/*: any*/),
                    "action": "THROW"
                  },
                  (v11/*: any*/),
                  {
                    "alias": "canEditVersions",
                    "args": (v12/*: any*/),
                    "concreteType": "JiraProjectAction",
                    "kind": "LinkedField",
                    "name": "action",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "RequiredField",
                        "field": (v13/*: any*/),
                        "action": "THROW"
                      }
                    ],
                    "storageKey": "action(type:\"MANAGE_VERSIONS\")"
                  },
                  (v14/*: any*/),
                  {
                    "kind": "RequiredField",
                    "field": {
                      "alias": "versions",
                      "args": [
                        (v15/*: any*/),
                        (v16/*: any*/),
                        (v17/*: any*/)
                      ],
                      "concreteType": "JiraVersionConnection",
                      "kind": "LinkedField",
                      "name": "__uiProject__versions_connection",
                      "plural": false,
                      "selections": [
                        {
                          "concreteType": "JiraVersionEdge",
                          "kind": "LinkedField",
                          "name": "edges",
                          "plural": true,
                          "selections": [
                            (v18/*: any*/),
                            (v19/*: any*/),
                            {
                              "concreteType": "JiraVersion",
                              "kind": "LinkedField",
                              "name": "node",
                              "plural": false,
                              "selections": [
                                (v18/*: any*/)
                              ]
                            }
                          ]
                        },
                        {
                          "concreteType": "QueryError",
                          "kind": "LinkedField",
                          "name": "errors",
                          "plural": true,
                          "selections": [
                            {
                              "kind": "LinkedField",
                              "name": "extensions",
                              "plural": true,
                              "selections": [
                                (v20/*: any*/)
                              ]
                            }
                          ]
                        },
                        (v21/*: any*/),
                        (v22/*: any*/)
                      ]
                    },
                    "action": "THROW"
                  }
                ]
              },
              "action": "THROW"
            }
          ]
        },
        "action": "THROW"
      },
      {
        "args": (v23/*: any*/),
        "kind": "FragmentSpread",
        "name": "Table_ReleasesProjectVersions"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v0/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "ProjectVersionsComponentQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v7/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProjectByKey",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              {
                "alias": "canEditVersions",
                "args": (v12/*: any*/),
                "concreteType": "JiraProjectAction",
                "kind": "LinkedField",
                "name": "action",
                "plural": false,
                "selections": [
                  (v13/*: any*/)
                ],
                "storageKey": "action(type:\"MANAGE_VERSIONS\")"
              },
              (v14/*: any*/),
              {
                "args": (v23/*: any*/),
                "concreteType": "JiraVersionConnection",
                "kind": "LinkedField",
                "name": "versions",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraVersionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      (v18/*: any*/),
                      (v19/*: any*/),
                      {
                        "concreteType": "JiraVersion",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v18/*: any*/),
                          (v24/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "status"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "description"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "startDate"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "releaseDate"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "overdue"
                          },
                          {
                            "alias": "allIssues",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "filter",
                                "value": "ALL"
                              }
                            ],
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issues",
                            "plural": false,
                            "selections": (v26/*: any*/),
                            "storageKey": "issues(filter:\"ALL\")"
                          },
                          {
                            "alias": "doneIssues",
                            "args": (v27/*: any*/),
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issues",
                            "plural": false,
                            "selections": (v26/*: any*/),
                            "storageKey": "issues(filter:\"DONE\")"
                          },
                          {
                            "alias": "done",
                            "args": (v27/*: any*/),
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issues",
                            "plural": false,
                            "selections": (v26/*: any*/),
                            "storageKey": "issues(filter:\"DONE\")"
                          },
                          {
                            "alias": "inProgress",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "filter",
                                "value": "IN_PROGRESS"
                              }
                            ],
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issues",
                            "plural": false,
                            "selections": (v26/*: any*/),
                            "storageKey": "issues(filter:\"IN_PROGRESS\")"
                          },
                          {
                            "alias": "toDo",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "filter",
                                "value": "TODO"
                              }
                            ],
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issues",
                            "plural": false,
                            "selections": (v26/*: any*/),
                            "storageKey": "issues(filter:\"TODO\")"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "versionId"
                          },
                          (v9/*: any*/),
                          (v22/*: any*/)
                        ]
                      }
                    ]
                  },
                  {
                    "concreteType": "QueryError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "extensions",
                        "plural": true,
                        "selections": [
                          (v18/*: any*/),
                          (v20/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v21/*: any*/),
                  (v22/*: any*/),
                  (v25/*: any*/)
                ]
              },
              {
                "args": (v23/*: any*/),
                "filters": [
                  "filter",
                  "searchString",
                  "sortBy"
                ],
                "handle": "connection",
                "key": "uiProject__versions",
                "kind": "LinkedHandle",
                "name": "versions"
              },
              (v24/*: any*/),
              {
                "kind": "ScalarField",
                "name": "projectType"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "0cd6689f58d70d089c5ce0d16c3651046806b0d99434650a0e51495ec7741474",
    "metadata": {
      "connection": [
        {
          "count": "initialLoadCount",
          "cursor": null,
          "direction": "forward",
          "path": [
            "jira",
            "jiraProjectByKey",
            "versions"
          ]
        }
      ]
    },
    "name": "ProjectVersionsComponentQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "a16ca98ca354ef2d3f69eaf4750cb039";

export default node;
